/**
 * The one DOM operation the portal's chrome needs.
 *
 * A near-twin of the editor's helper, duplicated rather than imported: the editor never ships, so
 * anything the portal reaches for from it would drag a dev-only package into the production bundle.
 * Two small copies are the price of that boundary.
 */

/** Creates an element with a class name and, optionally, its text content. */
export function element<TTag extends keyof HTMLElementTagNameMap>(
  tag: TTag,
  className: string,
  text?: string,
): HTMLElementTagNameMap[TTag] {
  const created = document.createElement(tag);
  created.className = className;
  if (text !== undefined) {
    created.textContent = text;
  }
  return created;
}
